<div class="modal-clean modal-clean--wide modal-webview">
    <div class="modal-clean__content --no-outer-padding">
        <div class="modal-clean__header">
            <div class="modal__close" (click)="close()"></div>
            <div class="modal__title">{{ title }}</div>
        </div>
        <iframe class="modal-webview__iframe" [src]="safeURL" frameborder="0"></iframe>
    </div>
</div>
